'use client'

import React, { useEffect, useState } from 'react'
import styles from './index.module.css'
import Arrow from '@/assets/svg/arrow.svg'
import { useTransitionRouter as useRouter } from 'next-view-transitions'

export default function Index() {
  const [articleTitle, setTitle] = useState('');
  const $router = useRouter();

  useEffect(() => {
    const label = document.title;
    setTitle(label)
  }, [])
  return (
    <div className={styles.context}>
      <div onClick={() => $router.back()} className={styles.back}>
        <Arrow className={styles['back-icon']} />
        Back</div>
      <span className={styles.title}>{articleTitle}</span>
    </div>
  )
}
